var _style, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightMoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28.3 28.3",
    style: {
      enableBackground: "new 0 0 28.3 28.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2D2D2D;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.5,1.5c0.7,0,1.5,0.1,2.3,0.2c0.7,0.2,0.9,0.7,0.9,0.9c0,0.2,0.1,0.9-0.6,1.3c-2.8,1.6-4.5,4.5-4.5,7.7 c0,4.9,4,8.8,8.8,8.8c0.6,0,1.1-0.1,1.7-0.2c0.1,0,0.1,0,0.2,0c0.6,0,1,0.4,1.1,0.7c0.1,0.2,0.2,0.7-0.2,1.2c-2.4,3-6,4.6-9.8,4.6 c-7,0-12.7-5.7-12.7-12.6C2.8,7.1,8.4,1.5,15.5,1.5 M15.5,0C7.6,0,1.3,6.3,1.3,14.2c0,7.8,6.3,14.1,14.2,14.1c4.4,0,8.4-2,11-5.2 c1.5-1.8,0.1-4.3-2.1-4.3c-0.2,0-0.3,0-0.5,0c-0.5,0.1-1,0.1-1.5,0.1c-4,0-7.3-3.2-7.3-7.3c0-2.7,1.4-5.1,3.7-6.4 c2.2-1.3,1.7-4.5-0.8-5C17.2,0.1,16.3,0,15.5,0L15.5,0z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-35,30c4.4,0,8.4-2,11-5.2c1.6-1.9-0.1-4.7-2.6-4.3c-4.6,0.9-8.8-2.6-8.8-7.2c0-2.7,1.4-5.1,3.7-6.4 c2.2-1.3,1.7-4.5-0.8-5c-0.8-0.1-1.7-0.2-2.5-0.2c-7.9,0-14.2,6.3-14.2,14.2C-49.2,23.7-42.9,30-35,30z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightMoon);
export default __webpack_public_path__ + "static/media/light-moon.811822d4474cbd173e67164e905177b2.svg";
export { ForwardRef as ReactComponent };